var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumbersLabelling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 991,
    height: 93,
    viewBox: "0 0 991 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.3244,
    cy: 61.235,
    r: 26.3244,
    fill: "#FF0000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 502.886,
    cy: 61.235,
    r: 26.3244,
    fill: "#FF0000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 939.448,
    cy: 54.8808,
    r: 26.3244,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M494.968 69.9299V67.0979L502.216 60.6659C502.76 60.1859 503.144 59.7339 503.368 59.3099C503.592 58.8859 503.704 58.4899 503.704 58.1219C503.704 57.5939 503.596 57.1259 503.38 56.7179C503.164 56.3019 502.86 55.9779 502.468 55.7459C502.076 55.5059 501.616 55.3859 501.088 55.3859C500.536 55.3859 500.048 55.5139 499.624 55.7699C499.208 56.0179 498.884 56.3499 498.652 56.7659C498.42 57.1739 498.312 57.6179 498.328 58.0979H494.968C494.968 56.9139 495.228 55.8899 495.748 55.0259C496.268 54.1619 496.992 53.4939 497.92 53.0219C498.848 52.5499 499.928 52.3139 501.16 52.3139C502.288 52.3139 503.296 52.5619 504.184 53.0579C505.08 53.5459 505.784 54.2299 506.296 55.1099C506.808 55.9899 507.064 57.0099 507.064 58.1699C507.064 59.0259 506.944 59.7379 506.704 60.3059C506.464 60.8659 506.108 61.3859 505.636 61.8659C505.164 62.3379 504.584 62.8739 503.896 63.4739L499.216 67.5779L498.952 66.8579H507.064V69.9299H494.968Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4481 69.9539V56.2259L19.2081 58.2179V54.6179L22.4481 52.6739H25.7841V69.9539H22.4481Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M937.488 64.2659C936.624 64.2659 935.8 64.0939 935.016 63.7499C934.232 63.3979 933.548 62.9059 932.964 62.2739C932.388 61.6419 931.976 60.8979 931.728 60.0419L934.896 59.2019C935.064 59.8339 935.392 60.3259 935.88 60.6779C936.376 61.0219 936.912 61.1939 937.488 61.1939C937.984 61.1939 938.436 61.0739 938.844 60.8339C939.26 60.5939 939.588 60.2699 939.828 59.8619C940.076 59.4539 940.2 59.0019 940.2 58.5059C940.2 57.7619 939.944 57.1259 939.432 56.5979C938.928 56.0619 938.28 55.7939 937.488 55.7939C937.248 55.7939 937.016 55.8299 936.792 55.9019C936.568 55.9659 936.352 56.0579 936.144 56.1779L934.68 53.6099L940.176 49.0499L940.416 49.7459H932.4V46.6739H943.2V49.7459L938.928 53.8739L938.904 52.9619C939.896 53.1139 940.732 53.4619 941.412 54.0059C942.1 54.5419 942.62 55.2059 942.972 55.9979C943.332 56.7819 943.512 57.6179 943.512 58.5059C943.512 59.5939 943.236 60.5739 942.684 61.4459C942.132 62.3099 941.4 62.9979 940.488 63.5099C939.576 64.0139 938.576 64.2659 937.488 64.2659Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61 50C83.7084 35.7194 138.204 -2.33586 271.569 1.23521C360.043 3.60425 427.578 32.9554 464 50",
    stroke: "black",
    strokeDasharray: "9 9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M538 74C558.849 79.2459 608.882 93.2254 731.326 91.9136C812.555 91.0433 874.561 80.2613 908 74",
    stroke: "black",
    strokeDasharray: "9 9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 957.559,
    y1: 27.7647,
    x2: 965.559,
    y2: 12.7647,
    stroke: "#FF0000"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 965.665,
    y1: 35.6292,
    x2: 986.665,
    y2: 16.6292,
    stroke: "#FF0000"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 970.835,
    y1: 44.5281,
    x2: 990.835,
    y2: 37.5281,
    stroke: "#FF0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbersLabelling);
export default __webpack_public_path__ + "static/media/numbers_labelling.9b1caa0b046e20982167e7c9c0a0f0b2.svg";
export { ForwardRef as ReactComponent };